import {createTastePreferences} from './taste-preferences.js';

const EXPERIENCE_LEVELS=new Set(['beginner','intermediate','advanced']);

export const SmokingExperienceLevel=Object.freeze({
  BEGINNER:'beginner',
  INTERMEDIATE:'intermediate',
  ADVANCED:'advanced'
});

function normaliseStringList(values,{maxItems=20,maxLength=64}={}){
  if(values==null)return [];
  if(!Array.isArray(values))throw new TypeError('Expected an array');
  const unique=[];
  const seen=new Set();
  for(const value of values){
    const item=String(value||'').trim().toLowerCase();
    if(!item)continue;
    if(item.length>maxLength)throw new TypeError('Preference value is too long');
    if(!seen.has(item)){
      seen.add(item);
      unique.push(item);
    }
  }
  if(unique.length>maxItems)throw new TypeError('Too many preference values');
  return unique;
}

function structuredCloneSafe(value){
  if(globalThis.structuredClone)return globalThis.structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

function optionalText(value,maxLength=160){
  if(value==null||value==='')return null;
  const text=String(value).trim();
  if(!text)return null;
  if(text.length>maxLength)throw new TypeError('Custom preference text is too long');
  return text;
}

export function createSmokingProfile({
  userId,
  experienceLevel=null,
  smokingGoals=[],
  customSmokingGoal=null,
  productPreferences=[],
  customProductPreference=null,
  tastePreferences={},
  profileVersion=1
}={}){
  const id=String(userId||'').trim();
  if(!id)throw new TypeError('userId is required');

  const experience=experienceLevel==null||experienceLevel===''
    ?null
    :String(experienceLevel).trim().toLowerCase();

  if(experience!==null&&!EXPERIENCE_LEVELS.has(experience)){
    throw new TypeError('Unsupported experience level');
  }

  const version=Number(profileVersion);
  if(!Number.isInteger(version)||version<1)throw new TypeError('profileVersion must be a positive integer');

  return Object.freeze({
    userId:id,
    experienceLevel:experience,
    smokingGoals:Object.freeze(normaliseStringList(smokingGoals)),
    customSmokingGoal:optionalText(customSmokingGoal),
    productPreferences:Object.freeze(normaliseStringList(productPreferences)),
    customProductPreference:optionalText(customProductPreference),
    tastePreferences:createTastePreferences(tastePreferences),
    profileVersion:version
  });
}

export function smokingProfileToRow(profile){
  const value=createSmokingProfile(profile);
  return Object.freeze({
    user_id:value.userId,
    experience_level:value.experienceLevel,
    smoking_goals:[...value.smokingGoals],
    smoking_goal_other:value.customSmokingGoal,
    product_preferences:[...value.productPreferences],
    product_preference_other:value.customProductPreference,
    taste_preferences:structuredCloneSafe(value.tastePreferences),
    profile_version:value.profileVersion
  });
}

export function smokingProfileFromRow(row={}){
  return createSmokingProfile({
    userId:row.user_id,
    experienceLevel:row.experience_level,
    smokingGoals:row.smoking_goals,
    customSmokingGoal:row.smoking_goal_other,
    productPreferences:row.product_preferences,
    customProductPreference:row.product_preference_other,
    tastePreferences:row.taste_preferences,
    profileVersion:row.profile_version
  });
}
